import React from "react"
import {useRoomParameters, useRoomSetup, useLocal} from "../AppContext"

export const ConditionsNoise = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const roomParameters = useRoomParameters()

    const noises = roomSetup.getNoises().map(noiseCode => {
        const noise = roomParameters.getNoise(noiseCode)
        return local.getLabel(noise.name)
    })

    return noises.length
        ? noises.join(", ")
        : local.__("ohne")
}
